import useSoftReRender, { useSoftReRenderValue, SoftReRenderProvider } from "./useSoftReRender";

export { useSoftReRenderValue, SoftReRenderProvider };

export default useSoftReRender;
